export default {
  header: 'Escolher Menu',
  open_now: 'Aberto Agora',
};
